import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/pro-regular-svg-icons/faArrowLeft";

import Button from "@/components/Global/Button/Button";
import TabHeader from "@/components/Global/Tabs/TabHeader";

import styles from "./HealthProfileHeader.module.scss";

export default function HealthProfileHeader({handleBack, children, backButtonText}) {
  return (
    <>
      <div className={`${styles.header} row mx-0 gx-0 align-items-center position-relative`}>
        <div className="col-auto">
          <Button variant="transparent" className="p-2" onClick={() => handleBack()} aria-label="go back">
            <FontAwesomeIcon icon={faArrowLeft} size="lg" className="ps-2" /> {backButtonText}
          </Button>
        </div>

        <div className="col-10 text-center fw-semibold">
          <h3 className="m-0 py-4">Health profile</h3>
        </div>

        <div className="col-12">
          <TabHeader id="health-profile" scrollToTop={true}>
            <TabHeader.Item id="about-you" className="py-3" isActive={true} aria-label="about you">
              About you
            </TabHeader.Item>
            <TabHeader.Item id="health-and-lifestyle" className="text-balance" aria-label="health and lifestyle">
              Health & lifestyle
            </TabHeader.Item>
            <TabHeader.Item id="contact-info" className="py-3" aria-label="contact info">
              Contact info
            </TabHeader.Item>
          </TabHeader>
        </div>
      </div>
    </>
  );
}
